var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HomeTopSlider'),_c('HomeAboutClinic'),_c('HomeNewsSlider'),_c('HomeVideoSlider'),(_vm.isLoaded)?_c('div',[_c('HomeBoxes')],1):_vm._e(),_c('HomeMobileBottomBar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }